var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBargebase2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 21,
    viewBox: "0 0 119 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2718 4.51178C0.272873 2.85255 1.46786 0.738281 3.40458 0.738281H115.595C117.532 0.738281 118.727 2.85255 117.728 4.51178L108.626 19.6312C108.175 20.3792 107.366 20.8366 106.493 20.8366H12.5071C11.6339 20.8366 10.8246 20.3792 10.3743 19.6312L1.2718 4.51178Z",
    fill: "url(#paint0_linear_7279_78595)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7279_78595",
    x1: -11.5523,
    y1: 20.8366,
    x2: 137.235,
    y2: 20.8366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106383,
    stopColor: "#FCAA16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888889,
    stopColor: "#EF687C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBargebase2);
export default __webpack_public_path__ + "static/media/bargebase2.c5fc0b7b8afe88f9175701b0892e50aa.svg";
export { ForwardRef as ReactComponent };